import styled from "styled-components";

export const Wrapper = styled.div`
    margin-top: 100px;
    /* height: 110vh; */
    width: 100%;
`;